import { useBreakpointValue } from "@gluestack-ui/themed";
import useToast from "@repo/core/components/core/Toast";
import { IModalRefProps } from "@repo/core/components/layout/Modal/types";
import {
  IModalOption,
  IModalTemplateType
} from "@repo/core/components/layout/ModalTemplate/types";
import { useNavigation } from "@repo/core/hooks/useNavigation";
import { useNewTransactionFlow } from "@repo/core/hooks/useNewTransactionFlow";
import { ROUTES } from "@repo/core/routes";
import { apiInstance } from "@repo/core/services/instances/api";
import { CardResource } from "@repo/core/services/resources/card";
import { useNewTransactionStore } from "@repo/core/stores/newTransaction";
import { useStoresAndShopkeepersStore } from "@repo/core/stores/storesAndShopkeepers";
import { useRef, useState } from "react";

const cardResource = new CardResource(apiInstance);

export const NewTransactionConfirmController = () => {
  // Hooks
  const { error } = useToast();
  const { replace } = useNavigation();
  const { navigateBack, navigateToNext, currentRouteConfig } =
    useNewTransactionFlow();
  const isMobile = useBreakpointValue({ base: true, md: false });

  // Store
  const {
    selectedProduct,
    resetNewTransaction,
    transactionValue,
    selectedInstallment,
    bonusValue,
    flowType
  } = useNewTransactionStore();
  const { selectedStore } = useStoresAndShopkeepersStore();

  // Refs & State
  const alertModalRef = useRef<IModalRefProps>(null);
  const [isValidatingPassword, setIsValidatingPassword] = useState(false);

  // Modal Options
  const alertOptions: IModalOption[] = [
    {
      label: "Voltar ao início",
      onPress: () => handleNavigateToHome(),
      type: IModalTemplateType.success
    },
    {
      label: "Ver comprovante",
      type: IModalTemplateType.outline,
      onPress: () => navigateToNext()
    }
  ];

  // Navigation Handlers
  const handleNavigateToHome = () => {
    replace(ROUTES.home);
    resetNewTransaction();
  };

  // Action Handlers
  const handleValidatePassword = async (password: string) => {
    if (!password) return;
    try {
      setIsValidatingPassword(true);
      const response = await cardResource.validateCardPassword(
        selectedProduct?.strPlasticoTitularNumero?.toString() || "",
        password
      );
      if (response.data) {
        alertModalRef.current?.open();
      }
    } catch (err) {
      error("Senha incorreta, por favor verifique a senha e tente novamente.");
    } finally {
      setIsValidatingPassword(false);
    }
  };

  return {
    // Layout
    isMobile,

    // State
    title: currentRouteConfig.title,
    isValidatingPassword,
    transactionValue,
    selectedInstallment,
    bonusValue,
    flowType,
    selectedStore,

    // Modal
    alertModalRef,
    alertOptions,

    // Handlers
    handleBack: navigateBack,
    handleConfirmCardPassword: handleValidatePassword
  };
};
